import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { Field, SelectField, TextareaField } from './Field';

const sample: Dictionary<{
  name: string;
  namePlaceholder: string;
  currency: string;
  notes: string;
  notesPlaceholder: string;
}> = {
  pl: {
    name: 'Nazwa',
    namePlaceholder: 'np. Konto oszczędnościowe',
    currency: 'Waluta',
    notes: 'Notatki',
    notesPlaceholder: 'Wszystko, co warto zapamiętać',
  },
  en: {
    name: 'Name',
    namePlaceholder: 'e.g. Savings account',
    currency: 'Currency',
    notes: 'Notes',
    notesPlaceholder: 'Anything worth remembering',
  },
};

export default {
  kind: 'component',
  title: { pl: 'Pole formularza', en: 'Field' },
  description: {
    pl: 'Etykieta z kontrolką, które powtarza każdy formularz. `id` jest wymagane, bo to ono je łączy. `SelectField` to samo dla `<select>`, a `TextareaField` dla kilku linii tekstu.',
    en: 'The label-plus-control pair every form repeats. `id` is required because it is what ties the two together. `SelectField` is the same for a `<select>`, and `TextareaField` for several lines of text.',
  },
  variants: [
    {
      name: { pl: 'Pole tekstowe', en: 'Text input' },
      render: (locale) => (
        <Field
          id="story-field-name"
          label={sample[locale].name}
          placeholder={sample[locale].namePlaceholder}
        />
      ),
    },
    {
      name: { pl: 'Lista wyboru', en: 'Select' },
      render: (locale) => (
        <SelectField
          id="story-field-currency"
          label={sample[locale].currency}
          defaultValue="PLN"
        >
          <option value="PLN">PLN</option>
          <option value="EUR">EUR</option>
          <option value="USD">USD</option>
        </SelectField>
      ),
    },
    {
      name: { pl: 'Pole wielowierszowe', en: 'Multi-line field' },
      render: (locale) => (
        <TextareaField
          id="story-field-notes"
          label={sample[locale].notes}
          placeholder={sample[locale].notesPlaceholder}
        />
      ),
    },
    {
      name: { pl: 'W formularzu', en: 'In a form' },
      render: (locale) => (
        <div className="form-stack">
          <Field id="story-form-name" label={sample[locale].name} />
          <SelectField id="story-form-currency" label={sample[locale].currency}>
            <option value="PLN">PLN</option>
            <option value="EUR">EUR</option>
          </SelectField>
          <TextareaField id="story-form-notes" label={sample[locale].notes} />
        </div>
      ),
    },
  ],
} satisfies Story;
